import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { ONBOARDING_FREE_SERVICE } from 'getting-started-shared-tasks/onboardingKeys';
import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { CUSTOMER_SERVICE_HUB_INTEREST } from '../constants/surveyConstants'; // @ts-expect-error ts-migrate(7016) FIXME: This will be migrated in the next phase

import { HubletUrl } from '../utils/urls';
import { CRM_SIGNUP, SERVICE_SIGNUP } from '../constants/signupConstants';
const servicesExperiencesChecks = [{
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: ONBOARDING_FREE_SERVICE,
      groupKey: FREE_GROUP_KEYS.freeServiceView
    };
  },
  checks: [{
    signupType: SERVICE_SIGNUP
  }]
}, {
  redirectPath: portalId => {
    return {
      url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
      view: ONBOARDING_VIEWS.SERVICE,
      onboardingKey: ONBOARDING_FREE_SERVICE,
      groupKey: FREE_GROUP_KEYS.freeServiceView
    };
  },
  checks: [{
    signupType: CRM_SIGNUP,
    survey: {
      hubInterest: CUSTOMER_SERVICE_HUB_INTEREST
    }
  }]
}];
export default servicesExperiencesChecks;